"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Cell_1 = require("../components/Cell");
const react_1 = __importDefault(require("react"));
const util_1 = require("../util");
const Column_1 = require("../components/Column");
exports.colFormatter = (cell, row, rowIndex, formatExtraData) => {
    const { col, colIndex, onAction, table } = formatExtraData;
    const { id, cell: { type, value: { variant, child }, }, } = col;
    const getChild = util_1.convertSerializedIntoJS(child, row, col);
    const value = {
        variant,
        child: (typeof getChild === "boolean" || typeof getChild === "number"
            ? getChild.toString()
            : getChild) ||
            (typeof row[id] === "boolean" || typeof row[id] === "number"
                ? row[id].toString()
                : row[id]) ||
            "",
    };
    return row.loading === col.id ? (react_1.default.createElement(Column_1.Loader, { col: col, row: row })) : (react_1.default.createElement(Cell_1.Cell, { colIndex: colIndex, table: table, rowIndex: rowIndex, col: col, row: row, type: type, value: value, onAction: onAction }));
};
//# sourceMappingURL=ColFormatters.js.map